import type { GetComparePatentData, PatentItemInfo } from '../types';

export const AddComparePatentService = Symbol.for('AddComparePatentService');

export interface AddComparePatentService {
    getComparePatent(q: string): Promise<GetComparePatentData>; // 查询对比数据

    saveLocalComparePatent(info: PatentItemInfo): Promise<void>; // 本地存储对比列表

    getLocalComparePatent(): Promise<PatentItemInfo[]>;
}